import React, { useContext, useEffect, useState } from "react";
import { loginservice } from "../../services/login.service";
import AuthContext from "../../store/auth-context";
import { useTranslation } from "react-i18next";
import cList from "../../constants/countryList.json";
import Otp from "./Otp";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Paper from "@material-ui/core/Paper";
import { createFilterOptions } from "@material-ui/lab/Autocomplete";
import { Link, useHistory } from "react-router-dom";
import { KeyboardDatePicker } from "@material-ui/pickers";
import {
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
  MenuItem,
  Snackbar,
  TextField,
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import { appservice } from "../../services/app.service";
import NumberFormat from "react-number-format";
import CloseIcon from "@material-ui/icons/Close";
import PrivacyPolicy from "./PrivacyPolicy";
import TermAndCon from "./TermAndCon";
import FingerprintIcon from "@mui/icons-material/Fingerprint";
import moment from "moment";
import { pushToDataLayer } from "../../utils/gtm";

function Register() {
  const authCtx = useContext(AuthContext);
  const { t } = useTranslation();
  const history = useHistory();

  const [loginMobile, setLoginMobile] = useState<string>("");
  const [loginMobileError, setLoginMobileError] = useState<boolean>(false);
  const [loginMobileErrorText, setLoginMobileErrorText] = useState<string>("");

  const [docId, setDocId] = useState<string>("");
  const [docIdError, setDocIdError] = useState<boolean>(false);
  const [docIdErrorText, setDocIdErrorText] = useState<string>("");
  const [docTypeList, setDocTypeList] = useState<any>([]);

  const [docType, setDocType] = useState(0);
  const [docTypeError, setDocTypeError] = useState<boolean>(false);

  const [tnc, setTnc] = useState<boolean>(false);
  const [isRegisteredUser, setIsRegisteredUser] = useState<boolean>(true);
  const [disableInput, setDisableInput] = useState<boolean>(false);

  const [callingCode, setCallingCode] = useState("");

  const [userRegisterModel, setRegisterUserModal] = useState<boolean>(false);
  const [userRegisterModelMessage, setRegisterUserMessage] = useState<any>("");
  const [tncModel, setTncModel] = useState<boolean>(false);
  const [privacyModel, setPrivacyModel] = useState<boolean>(false);
  const [confirmationModel, setConfirmationModel] = useState<boolean>(false);

  const [selectedDOB, setSelectedDOB] = useState<Date | null>(null);
  const [selectedDOBError, setSelectedDOBError] = useState<boolean>(false);
  const [selectedDOBErrorText, setSelectedDOBErrorText] = useState<string>("");
  const [referanceId, setReferanceId] = useState<string>("");

  const brandName = localStorage.getItem("brandName");
  const uaePassLogin: any = process.env.REACT_APP_UAEPASS_LOGIN;
  const lang = localStorage.getItem("lang") ?? "en";
  //const uaePassLogin: any = `https://stg-id.uaepass.ae/idshub/authorize?response_type=code&client_id=sandbox_stage&scope=urn:uae:digitalid:profile:general&state=HnlHOJTkTb66Y5H&redirect_uri=http://localhost:3000/home/login&acr_values=urn:safelayer:tws:policies:authentication:level:low`;

  const handleClose = () => setRegisterUserModal(false);
  //const handleShow = () => setRegisterUserModal(true);

  const toggleTnC = () => setTnc((value) => !value);

  const togglePassworBlock = () => {
    setCallingCode(authCtx.cCode);
    setLoginMobile(authCtx.userMobile);
    setIsRegisteredUser(true);

    toggleTnC();
  };

  useEffect(() => {
    if (authCtx.cCode === "" && authCtx.userMobile === "") {
      setCallingCode("971");
    } else {
      setCallingCode(authCtx.cCode);
      setLoginMobile(authCtx.userMobile);
    }
    fetchDocTypeList();
    // eslint-disable-next-line
  }, []);
  const handleComfirmationClose = () => setConfirmationModel(false);

  const fetchDocTypeList = async () => {
    let res = await appservice.getDocumentType();
    setDocTypeList(res);
  };

  const handleDOBChange = (date: any | null) => {
    if (date !== null && date.toString() !== "Invalid Date") {
      const offset = date.getTimezoneOffset();
      date = new Date(date.getTime() - offset * 60 * 1000);
      setSelectedDOB(date);
    }
    let isValid = moment(date, "DD/MM/YYYY", true).isValid();
    if (isValid) {
      let today = moment(new Date().getDate() + 1, "DD/MM/YYYY");
      let selectedDate = moment(date, "DD/MM/YYYY");
      if (moment(selectedDate).isAfter(today)) {
        setSelectedDOBError(true);
        setSelectedDOBErrorText(t("dobRangeError"));
      } else {
        setSelectedDOBError(false);
        setSelectedDOBErrorText("");
      }
    } else {
      setSelectedDOBError(true);
      setSelectedDOBErrorText(t("dobFormatError"));
    }
  };

  const handleMobileChange = (e: any) => {
    setLoginMobile(e.target.value);
    if (e.target.value === "" || e.target.value.trim() === "") {
      setLoginMobileError(true);
      setLoginMobileErrorText("");
    } else {
      if (e.target.value.length < 8) {
        setLoginMobileError(true);
        setLoginMobileErrorText(t("Please enter valid Mobile Number"));
      } else {
        setLoginMobileError(false);
        setLoginMobileErrorText("");
      }
    }
  };

  const handleDocIdChange = (e: any) => {
    let pattern = /^784[0-9]{12}$/;
    if (docType === 1) {
      let text = e.target.value;
      let emirateId = text.replace(/-/g, "").trim();
      setDocId(emirateId);
      if (pattern.test(emirateId)) {
        if (emirateId.length < 8) {
          setDocIdError(true);
          setDocIdErrorText(t("Please enter valid Emirates ID"));
        } else {
          setDocIdError(false);
          setDocIdErrorText("");
        }
      } else {
        setDocIdError(true);
        setDocIdErrorText(t("Please enter valid Emirates ID"));
      }
    } else {
      setDocId(e.target.value);
      if (e.target.value === "" || e.target.value.trim() === "") {
        setDocIdError(true);
        setDocIdErrorText("");
      } else if (e.target.value.length < 6) {
        setDocIdError(true);
        setDocIdErrorText(t("Please enter correct Document ID"));
      } else {
        setDocIdError(false);
        setDocIdErrorText("");
      }
    }
  };

  const validationForm = () => {
    let isValid: boolean = true;

    if (selectedDOB === null || selectedDOBError) {
      setSelectedDOBError(true);
      isValid = false;
    }

    if (docId.trim() === "" || docIdError) {
      setDocIdError(true);
      isValid = false;
    }

    if (docType === 0) {
      setDocTypeError(true);
      isValid = false;
    }

    if (loginMobile.trim() === "" || loginMobile.length < 8) {
      setLoginMobileError(true);
      setLoginMobileErrorText(t("Please enter valid Mobile Number"));
      isValid = false;
    }
    return isValid;
  };

  function checkEmirateId() {
    let isValid: boolean = true;
    if (docType.toString() === "1") {
      const emirateId = docId;
      const dobYear = moment(selectedDOB, "YYYY-MM-DD").format("YYYY");
      const compereCodeWith =
        "784" + dobYear + emirateId.toString().slice(7, emirateId.length);
      if (emirateId !== compereCodeWith) {
        isValid = false;
      }
    }
    return isValid;
  }

  let checkUser = async () => {
    // PUSH GTM EVENT
  pushToDataLayer({
    event: 'button_click',
    button_name: 'Continue Registration',
    button_location: 'registration_page',
    brand_name: brandName || 'Burjeel'
  });
    authCtx.setDocumetsDetails(docType, docId);
    setDisableInput(true);
    setConfirmationModel(false);

    const data = {
      callingCode: callingCode,
      loginMobile: loginMobile,
      isInvokedForLogin: false,
      dateOfBirth: selectedDOB,
      documentTypeId: docType,
      documentId: docId,
      referenceId: referanceId,
    };

    authCtx.toggleLoader(true);

    if (validationForm()) {
      if (checkEmirateId()) {
        let res = await loginservice.checkUser(data);
        authCtx.setMobile(callingCode, loginMobile);
        if (res.isExistingUser === true) {
          setIsRegisteredUser(true);
          setRegisterUserModal(true);
          setRegisterUserMessage(
            t(
              "This mobile number is already registered with us. Please try logging in using this number"
            )
          );
          authCtx.toggleLoader(false);
          setTimeout(() => {
            history.push("/home/login");
          }, 2000);
        } else if (res.otpSent) {
          setReferanceId(res.referenceId);
          setIsRegisteredUser(false);
          authCtx.toggleLoader(false);
        }
      } else {
        authCtx.toggleLoader(false);
        setRegisterUserModal(true);
        setRegisterUserMessage(t("Invalid Emirates Id or date of birth"));
      }
    } else {
      setRegisterUserModal(true);
      setRegisterUserMessage(t("All fields are required"));
    }
    authCtx.toggleLoader(false);
  };

  const Login = (e: any) => {
    e.preventDefault();
    history.push("/home/login");
  };

  const handleTncClose = () => setTncModel(false);
  const handlePrivacyClose = () => setPrivacyModel(false);

  const navigateToUAEPass = (e: any) => {
    // PUSH GTM EVENT
    pushToDataLayer({
      event: 'button_click',
      button_name: 'UAE Pass Sign Up',
      button_location: 'registration_page',
      brand_name: brandName || 'Burjeel'
    });
    if (lang === "ar") {
      localStorage.setItem("processCount", "0");
    }
    e.preventDefault();
    window.location.replace(
      uaePassLogin + "&ui_locales=" + authCtx.selectedLanguage
    );
  };

  return (
    <div id="login">
      {isRegisteredUser && (
        <div className="">
          <h3 className="mt-5 fw-500">{t("Create an account.")}</h3>
          {/* <small className="text-muted"> {t("loginSubTitle")}</small> */}
          <div className="mb-3 mt-3">
            <div
              className={"input-group " + (disableInput ? "avoid-clicks" : "")}
            >
              {cList && callingCode && (
                <Autocomplete
                  id="country-select-demo"
                  options={cList}
                  disableClearable
                  autoHighlight
                  size="small"
                  defaultValue={cList.find((x) => x.phoneCode === callingCode)}
                  onChange={(event, value) => {
                    setCallingCode(value.phoneCode);
                  }}
                  filterOptions={createFilterOptions({
                    stringify: (option) => "+" + option.phoneCode + option.name,
                  })}
                  getOptionLabel={(option) =>
                    authCtx.selectedLanguage === "en"
                      ? "+" + option.phoneCode
                      : option.phoneCode + "+"
                  }
                  PaperComponent={({ children }) => (
                    <Paper style={{ minWidth: "327px" }}>{children}</Paper>
                  )}
                  style={{ minWidth: "100px" }}
                  renderOption={(option) => (
                    <>
                      {option.name} (+{option.phoneCode})
                    </>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="medium"
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
              )}
              <TextField
                autoFocus
                required
                autoComplete="off"
                id="loginMobile"
                label={t("Mobile No.*")}
                name="loginMobile"
                className="form-control"
                variant="outlined"
                size="medium"
                inputProps={{ maxLength: 10 }}
                value={loginMobile}
                onKeyPress={(event) => {
                  if (!/[0-9]/.test(event.key)) {
                    event.preventDefault();
                  }
                }}
                onChange={(e: any) => {
                  handleMobileChange(e);
                }}
                error={loginMobileError}
                helperText={loginMobileErrorText}
              />
            </div>
          </div>
          <div className="mb-3 mt-3">
            <TextField
              required
              select
              id="docType"
              label={t("Document Type*")}
              className="w-100  "
              variant="outlined"
              error={docTypeError}
              size="medium"
              value={docType === 0 ? "" : docType}
              onChange={(e: any) => {
                setDocType(e.target.value);
                setDocId("");
              }}
            >
              {docTypeList &&
                docTypeList.map((item: any) => (
                  <MenuItem value={item.id}>{item.text}</MenuItem>
                ))}
            </TextField>
          </div>
          <div className="mb-3 mt-3">
            {docType === 1 ? (
              <NumberFormat
                required
                customInput={TextField}
                id="docId1"
                className="w-100"
                size="medium"
                variant="outlined"
                format="###-####-#######-#"
                label={t("Document ID*")}
                error={docIdError}
                helperText={docIdErrorText}
                value={docId}
                onChange={(e: any) => {
                  handleDocIdChange(e);
                }}
              />
            ) : (
              <TextField
                required
                id="docId"
                label={t("Document ID*")}
                className="w-100"
                variant="outlined"
                size="medium"
                type="tel"
                inputProps={{ maxLength: 15, minLength: 6 }}
                error={docIdError}
                helperText={docIdErrorText}
                value={docId}
                onChange={(e: any) => {
                  handleDocIdChange(e);
                }}
              />
            )}
          </div>
          <div className="mb-3 mt-3">
            <KeyboardDatePicker
              required
              autoOk={true}
              disableFuture
              size="medium"
              variant="inline"
              inputVariant="outlined"
              format="dd/MM/yyyy"
              id="dob"
              views={["year", "month", "date"]}
              label={t("DOB*")}
              error={selectedDOBError}
              helperText={selectedDOBErrorText}
              value={selectedDOB}
              onChange={handleDOBChange}
              KeyboardButtonProps={{
                "aria-label": "change date",
              }}
              className="m-0  w-100"
            />
          </div>
          <div className="mb-2 form-check my-3">
            <input
              type="checkbox"
              className="form-check-input"
              id="agree"
              onChange={toggleTnC}
            />
            <label className="form-check-label fw-normal fs-12" htmlFor="agree">
              {t("I agree with")} &nbsp;
              <Link
                to="#"
                className="btn-link"
                onClick={(e) => {
                  e.preventDefault();
                  setTncModel(true);
                }}
              >
                {t("Terms and Conditions")}
              </Link>{" "}
              &amp;{" "}
              <Link
                to="#"
                className="btn-link "
                onClick={(e) => {
                  e.preventDefault();
                  setPrivacyModel(true);
                }}
              >
                {t("Privacy Policy")}
              </Link>
            </label>
          </div>
          <button
            type="submit"
            id="btnContinue"
            className="btn btn-primary w-100 mt-2 fs-18"
            disabled={
              !loginMobile || !tnc || docIdError || !docType || selectedDOBError
            }
            onClick={() => setConfirmationModel(true)}
          >
            {" "}
            {t("Continue")}
          </button>

          <div
            className="m-2 text-center position-relative mt-3 mb-3"
            id="login_or"
          >
            <strong>{t("or")}</strong>
          </div>

          <div className="text-center">
            <a href="#" className="" onClick={(e) => navigateToUAEPass(e)}>
              <img
                src={
                  authCtx.selectedLanguage === "en"
                    ? "../assets/images/UAEPASS_Sign_up_large.png"
                    : "../assets/images/UAEPASS_Sign_up_large_Ar.png"
                }
                className="img-fluid"
                alt=""
                height="54px"
              />
            </a>
          </div>

          <div className="d-flex align-items-center mt-3 mb-5 ">
            <h6 className="m-0"> {t("Already have an account ?")}</h6>
            <Link to="#" className="fs-16 ms-2" onClick={(e) => Login(e)}>
              {t("Login")}{" "}
            </Link>
          </div>
        </div>
      )}

      {!isRegisteredUser && (
        <div className="">
          <Otp
            ccode={callingCode}
            loginMobile={loginMobile}
            isInvokedForLogin={false}
            onClick={() => togglePassworBlock()}
            selectedDOB={selectedDOB}
            docType={docType}
            docId={docId}
            referanceId={referanceId}
          />
        </div>
      )}

      <Dialog
        open={tncModel}
        fullWidth={true}
        maxWidth="sm"
        onClose={handleTncClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        dir="ltr"
      >
        <DialogTitle id="alert-dialog-title">
          Terms And Condition
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={handleTncClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="pt-0">
          <DialogContentText id="alert-dialog-description">
            <TermAndCon />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        open={privacyModel}
        fullWidth={true}
        maxWidth="sm"
        onClose={handlePrivacyClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        dir="ltr"
      >
        <DialogTitle id="alert-dialog-title">
          Privacy Policy
          <IconButton
            className="float-end p-1"
            aria-label="close"
            onClick={handlePrivacyClose}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>
        <DialogContent className="pt-0">
          <DialogContentText id="alert-dialog-description">
            <PrivacyPolicy />
          </DialogContentText>
        </DialogContent>
      </Dialog>

      <Dialog
        fullWidth
        maxWidth="sm"
        open={confirmationModel}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle className="text-primary">{t("Confirmation")}</DialogTitle>
        <DialogContent>
          {" "}
          <p className="fs-16 fw-600">
            {t(
              "Please check the mobile no, document type and document number, you will not be able to update it later.Do you want to proceed?"
            )}
          </p>
        </DialogContent>
        <DialogActions>
          {" "}
          <button onClick={handleComfirmationClose} className="btn btn-primary">
            {t("Cancel")}
          </button>
          <button onClick={checkUser} className="btn btn-primary">
            {t("Yes")}
          </button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={userRegisterModel}
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <Alert onClose={handleClose} severity="error">
          {userRegisterModelMessage}
        </Alert>
      </Snackbar>
    </div>
  );
}

export default Register;
